import { DeleteRoomComplete, GetRoomsComplete, UpdateRoomComplete, UpsertRoomsComplete } from './rooms.actions'
import { adapter, initialState, State } from './rooms.state'
import { Action, createReducer, on } from '@ngrx/store'
import { updateOne } from '@tokeet/tv3-platform'
import { upsertMany } from '@tokeet-frontend/utility'

export const reducer = createReducer(
  initialState,
  on(GetRoomsComplete, (state, { rooms }) => adapter.setAll(rooms, { ...state, isLoaded: true })),
  on(UpdateRoomComplete, (state, { update }) => updateOne(adapter, update, state)),
  on(UpsertRoomsComplete, (state, { rooms }) => upsertMany(adapter, rooms, state)),
  on(DeleteRoomComplete, (state, { room }) => adapter.removeOne(room.pkey, state))
)

export function roomsReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
